/* eslint-disable camelcase */
(function () {
  'use strict';
  /* global Intl */

  class DeviceHealthConfigurationCtrl {
    constructor($scope, $document, $log, $window, Authenticator, safetyService,
      Keys, ServiceVfiltro, FactoryVfiltro, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys) {
      this.log = $log;
      this.scope = $scope;
      this.window = $window;
      this.document = $document[0];
      this.safetyService = safetyService;
      this.safetyApp = 'safetyApp';
      this.deviceHealthConfiguration = './DeviceHealthConfigurationPageRoute';
      this.componentId = 'safety-app-device-health-configuration';
      this.authenticator = Authenticator;
      this.featureOuService = FeatureOuService;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.isFeatureFlagDeviceHealthConfigurationPageEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ENABLE_DEVICE_HEALTY_NOTIFICATION_SETTINGS);
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      let filterFromService = null;

      this.serviceVfiltro.init(FactoryVfiltro.get([
        {
          key: this.keys.uo.name
        }
      ]))
      .then((result) => {
        filterFromService = result.filtro;
      })
      .catch((error) => {
        this.log.error('Error initializing filter:', error);
      })
      .finally(() => {
        this.authenticator.getUser()
          .then(user => {
            let finalFilter = null;
            if (filterFromService) {
              finalFilter = filterFromService;
            } else {
              finalFilter = this.getStoredOUFilter(user.id);
            }
            this.loadPage(finalFilter, user);
          })
          .catch(error => {
            this.log.error('Critical Error: Failed to fetch user in finally block:', error);
            this.loadPage(null, null);
          });
      });

      this.scope.$on('$destroy', () => {
        this.safetyService.unmountReactComponent();
      });
    }

    getStoredOUFilter(userId) {
      if (!userId) {
        return null;
      }
      const storedVFilter = this.window.localStorage.getItem(`vfiltro-${userId}`);
      return storedVFilter ? {uo_permissao: angular.fromJson(storedVFilter).uo} : null;
    }

    loadPage(filter, user) {
      if (!this.isFeatureFlagDeviceHealthConfigurationPageEnabled || !user || !user.id) {
        return;
      }

      const finalFilter = filter || this.getStoredOUFilter(user.id),
          props = {
            filter: finalFilter,
            user: user
          },
          containerElement = this.document.getElementById(this.componentId);

      if (!containerElement) {
        this.log.error(`Container element with ID '${this.componentId}' not found in DOM when calling loadReactComponent.`);
        return;
      }
      this.safetyService.loadReactComponent(
        this.safetyApp,
        this.deviceHealthConfiguration,
        this.componentId,
        props
      );
    }
  }
  angular
    .module('SubpaginasEventos')
    .controller('DeviceHealthConfigurationCtrl', DeviceHealthConfigurationCtrl);
}());
